import React from 'react';
import styled from 'styled-components';

import Button from './ui/Controls/Button';
import ChatEnvelope from './ui/SVGs/ChatEnvelope';
import useGlobal from '../store';

const ContactCardStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    width: 100%;
    font-size: 0.7rem;
    background-color: ${(props) => props.theme.colors.secondary};
    box-sizing: border-box;

    @media screen and (min-width: 768px) {
        height: 415px;
    }

    .contact__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 36px;
        color: #ffffff;
        font: 1.5rem ${(props) => props.theme.fonts[0]}, sans-serif;
        letter-spacing: 0.02px;
        line-height: 3rem;

        @media screen and (min-width: 1024px) {
            font-size: 2rem;
            letter-spacing: 0.03px;
        }

        &::after {
            content: ' ';
            display: block;
            width: 90px;
            height: 4px;
            margin-top: 18px;
            background-color: #d4f7ee;
        }
    }

    .contact__body {
        height: 34px;
        color: #ffffff;
        font: 300 1.25rem ${(props) => props.theme.fonts[0]}, sans-serif;
        letter-spacing: 0;
        line-height: 2.125rem;
        margin-top: 28px;

        @media screen and (min-width: 1024px) {
            font: 1.5rem ${(props) => props.theme.fonts[0]}, sans-serif;
        }
    }

    .contact-us-button {
        margin: 44px 0 100px;
        border: 1px solid #fff;
    }
`;
export default function ContactCard() {
    const [globalState, globalActions] = useGlobal();
    const defaultSection = [{ main: {}, detail: [] }];

    const {
        home: {
            get_in_touch: [
                { main: get_in_touch_main_details },
            ] = defaultSection,
        },
    } = globalState;

    const conatctLink =
        get_in_touch_main_details.links &&
        get_in_touch_main_details.links.length > 0 &&
        get_in_touch_main_details.links[0]?.url?.href;
    const linkText =
        get_in_touch_main_details.links &&
        get_in_touch_main_details.links.length > 0 &&
        get_in_touch_main_details.links[0]?.url?.title;
    return (
        <div className="contact_background">
            <ContactCardStyled>
                <ChatEnvelope />
                <p className="contact__header">
                    {get_in_touch_main_details?.heading?.text}
                </p>
                <p className="contact__body">
                    {get_in_touch_main_details?.body?.text}.
                </p>
                <Button
                    className="contact-us-button"
                    linkURL={conatctLink}
                    text={linkText}
                />
            </ContactCardStyled>
        </div>
    );
}
